import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {EventBusService} from "../../../../core/services/event-bus.service";
import {ImporterService} from "../../../../core/services/importer.service";
import {MatDialogRef} from "@angular/material/dialog";
import {IVerification} from "../../../../shared/model/interface/verification-import.interface";
import {tap} from "rxjs/operators";
import {DictionaryPosition} from "../../../../shared/model/dictionary.model";
import {Observable} from "rxjs";

@Component({
  selector: 'app-bik-import-report',
  templateUrl: './bik-import-report.component.html',
  styleUrls: ['./bik-import-report.component.scss']
})
export class BikImportReportComponent implements OnInit {

  importBikVerificationForm: FormGroup;

  constructor(private _formBuilder: FormBuilder,
              private _eventBusService: EventBusService,
              private _importerService: ImporterService,
              private _dialogRef: MatDialogRef<BikImportReportComponent>) { }

  ngOnInit(): void {
    this._createForm();
  }

  importBikVerification() {
    const payload = this._createImportBikVerificationPayload();
    const request = this._createImportBikVerificationRequest(payload);
    return this._handleRequest(request);
  }

  private _createForm() {
    this.importBikVerificationForm = this._formBuilder.group({
      file: [null, Validators.required]
    })
  }

  get file() {
    return this.importBikVerificationForm.get('file') as FormControl;
  }

  private _createImportBikVerificationRequest(payload: IVerification) {
    return this._importerService.importBikVerification(payload)
      .pipe(
        tap(_ => this._eventBusService.display(DictionaryPosition.OK))
      )
  }

  private _createImportBikVerificationPayload(): IVerification {
    return {
      file: this.importBikVerificationForm.value.file
    } as IVerification
  }

  private _handleRequest(request: Observable<any>) {
    return request.subscribe(_ => this._dialogRef.close(true));
  }

}
